<template>
  <div class="password-settings">
    <var-input v-model="oldPassword" type="password" label="当前密码" placeholder="请输入当前密码" />
    <var-input v-model="newPassword" type="password" label="新密码" placeholder="请输入新密码（至少6位）" />
    <var-input v-model="confirmPassword" type="password" label="确认密码" placeholder="请再次输入新密码" />

    <div v-if="resultMessage" class="result-tip" :class="resultType">
      {{ resultMessage }}
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { Snackbar } from '@varlet/ui'
import { useAppStore } from '@/stores'
import { userApi } from '@/api'

const appStore = useAppStore()

const oldPassword = ref('')
const newPassword = ref('')
const confirmPassword = ref('')
const resultMessage = ref('')
const resultType = ref('')

// ===== 修改密码（由底部按钮调用） =====
async function savePassword() {
  resultMessage.value = ''
  resultType.value = ''

  if (!oldPassword.value) {
    resultMessage.value = '请输入当前密码'
    resultType.value = 'error'
    return false
  }
  if (newPassword.value.length < 6) {
    resultMessage.value = '新密码至少6位'
    resultType.value = 'error'
    return false
  }
  if (newPassword.value !== confirmPassword.value) {
    resultMessage.value = '两次输入密码不一致'
    resultType.value = 'error'
    return false
  }

  try {
    const data = await userApi.updateUser(appStore.currentUser, { password: newPassword.value })
    if (data?.success) {
      resultMessage.value = '✅ 密码修改成功！'
      resultType.value = 'success'
      oldPassword.value = ''
      newPassword.value = ''
      confirmPassword.value = ''
      Snackbar.success('密码修改成功')
      return true
    } else {
      resultMessage.value = '❌ ' + (data?.msg || '修改失败')
      resultType.value = 'error'
      return false
    }
  } catch (err) {
    resultMessage.value = '❌ ' + err.message
    resultType.value = 'error'
    return false
  }
}

defineExpose({ savePassword })
</script>

<style scoped>
.password-settings {
  padding: 4px 0;
}

.result-tip {
  font-size: 13px;
  padding: 8px 12px;
  border-radius: 4px;
  margin-top: 12px;
}

.result-tip.success {
  color: #67c23a;
  background: #f0f9eb;
}

.result-tip.error {
  color: #f56c6c;
  background: #fef0f0;
}
</style>